import './LabeledField.css';

import React from 'react';

import '../Input.css';

interface LabeledFieldProps {
  label: string;
  /** Associate the label with a control (`id` on the input or select). */
  htmlFor?: string;
  children: React.ReactNode;
  className?: string;
}

/**
 * Shared label + control spacing for form fields (matches Input label rhythm).
 */
const LabeledField: React.FC<LabeledFieldProps> = ({
  label,
  htmlFor,
  children,
  className = '',
}) => (
  <div className={`labeled-field ${className}`.trim()}>
    <label className="input-label" htmlFor={htmlFor}>
      {label}
    </label>
    <div className="labeled-field__control">{children}</div>
  </div>
);

export default LabeledField;
